/* global axios */
import ApiClient from './ApiClient';

class AgentBreaksAPI extends ApiClient {
  constructor() {
    super('agent_break_sessions', { accountScoped: true, apiVersion: 'v2' });
  }

  startBreak({ breakReasonId }) {
    return axios.post(`${this.url}/start_break`, {
      break_reason_id: breakReasonId,
    });
  }

  endBreak() {
    return axios.post(`${this.url}/end_break`);
  }

  // GK-HUB: Added teamId param for team filter
  getSessions({ from, to, agentId, teamId } = {}) {
    return axios.get(this.url, {
      params: {
        since: from,
        until: to,
        agent_id: agentId,
        team_id: teamId,
      },
    });
  }
}

export default new AgentBreaksAPI();
